import React from 'react';
import styles from './ReceivedInventory.module.scss';
import FilterInTable from '../../../../../Manage/FilterInTable';
import DatatableComponent from '../../../../../../components/common/DatatableComponent/DatatableComponent';

const data = [
    {
        id: 1,
        shipmentId: 'SHIP-001',
        productId: '3475943',
        productName: 'Blue colored headphones',
        skuId: 'SKU-001',
        quantity: 200,
        warehouse: 'Warehouse A',
        status: 'Received',
    },
    {
        id: 2,
        shipmentId: 'SHIP-001',
        productId: '3475943',
        productName: 'Blue colored headphones',
        skuId: 'SKU-001',
        quantity: 200,
        warehouse: 'Warehouse A',
        status: 'In processing',
    },
    {
        id: 3,
        shipmentId: 'SHIP-001',
        productId: '3475943',
        productName: 'Blue colored headphones',
        skuId: 'SKU-001',
        quantity: 200,
        warehouse: 'Warehouse A',
        status: 'Received',
    },
    {
        id: 4,
        shipmentId: 'SHIP-001',
        productId: '3475943',
        productName: 'Blue colored headphones',
        skuId: 'SKU-001',
        quantity: 200,
        warehouse: 'Warehouse A',
        status: 'Received',
    },
    {
        id: 5,
        shipmentId: 'SHIP-001',
        productId: '3475943',
        productName: 'Blue colored headphones',
        skuId: 'SKU-001',
        quantity: 200,
        warehouse: 'Warehouse A',
        status: 'Received',
    },
];

const columns = [
    {
        name: 'Shipment ID',
        selector: (row) => row.shipmentId,
        sortable: true,
        minWidth: "160px",
    },
    {
        name: 'Product ID',
        selector: (row) => row.productId,
        sortable: true,
        minWidth: "140px",
    },
    {
        name: 'Product Name',
        selector: (row) => row.productName,
        sortable: true,
        maxWidth: '280px',
        minWidth: "220px",
    },
    {
        name: 'SKU ID',
        selector: (row) => row.skuId,
        sortable: true,
        minWidth: "120px",
    },
    {
        name: 'Quantity Received',
        selector: (row) => row.quantity,
        sortable: true,
        maxWidth: '220px',
        minWidth: "200px",
    },
    {
        name: 'Warehouse Location',
        selector: (row) => row.warehouse,
        sortable: true,
        maxWidth: '250px',
        minWidth: "220px",
    },
    {
        name: 'Status',
        cell: (row) => (
            <span className={getStatusClass(row.status)}>{row.status}</span>
        ),
        sortable: true,
        minWidth: "140px",
    },
];

const getStatusClass = (status) => {
    switch (status.toLowerCase()) {
        case 'in processing':
            return styles.statusInProcessing;
        case 'received':
            return styles.statusReceived;
        default:
            return '';
    }
};


const ReceivedInventory = () => {

    return (
        <div className={styles.mainContainer}>
            <h4 className={styles.sectionHeading}>Received Inventory</h4>

            <div className={styles.receivedInventoryContainer}>

                <FilterInTable componentName={"Received Inventory"} />

                <div className={styles.inventoryTable}>
                    <DatatableComponent
                        columns={columns}
                        data={data}
                        pagination
                        highlightOnHover
                        type="yellow-bordered"
                    />
                </div>
            </div>
        </div>
    )
}

export default ReceivedInventory;